import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'importError',
    serviceName: 'shopadmin',
    query: gql`
      query importError(
        $ids: [String]
        $barcodes: [String]
        $shop_ids: [String]
        $title: String
        $description: String
        $action_types: [String]
        $is_active: Int
        $file_name: String
        $withs: [String]
        $page: Int
        $limit: Int
        $orderBy_field: String
        $orderBy_direction: String
      ) {
        importError(
          ids: $ids
          barcodes: $barcodes
          shop_ids: $shop_ids
          title: $title
          description: $description
          action_types: $action_types
          is_active: $is_active
          file_name: $file_name
          withs: $withs
          page: $page
          limit: $limit
          orderBy_field: $orderBy_field
          orderBy_direction: $orderBy_direction
        ) {
          import_error_records {
            total
            last_page
            data {
              id
              title
              barcode
              me_price
              action_type
              shop {
                title
              }
              description
            }
          }
          action_types
          descriptions
        }
      }
    `,
  },
  assignment: {
    name: 'importError',
    serviceName: 'shopadmin',
    query: gql`
      query importError($ids: [String]) {
        importError(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
